import { render, staticRenderFns } from "./PeopleHorizontalList.vue?vue&type=template&id=fc12ad24"
import script from "./PeopleHorizontalList.vue?vue&type=script&lang=js"
export * from "./PeopleHorizontalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports